const wowApp = require('angular').module('wowApp.shop');

//Define Directives
wowApp.directive('featurePromo', ['StorePickerService', 'StorePickerPanelService', 'AtmService', '$timeout', '$rootScope', require('./feature-promo-directive')]);
wowApp.directive('featureDelivery', ['StorePickerPanelService', 'StorePickerService', 'AtmService', '$state', '$rootScope', 'BwsNotificationService', require('./features/feature-delivery/feature-delivery-directive')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/feature-promo/index.js
 **/